import React, { useState } from 'react';
import { config } from '@keytrade/functions';
import { Icon } from '@keytrade/components-icon';
import useIsMobile from '@/hooks/useIsMobile';
import useTranslations from '@/hooks/useTranslations';
import VideoLink from '@/components/VideoLink';
import NoDataNotification from '@/components/filters/NoDataNotification';

import MediaItem, { MediaItemType } from './MediaItem';
import {
  Wrapper,
  CardWrapper,
  List,
  ListElement,
  Overlay,
  BackgroundLayer,
  VideoModal,
  CloseWrapper,
} from './MediaListing.styled';

const { list: colors } = config.colors;

export type MediaListing = {
  featuredItem: MediaItemType;
  items: MediaItemType[];
  isMediaWall: boolean;
  isDark: boolean;
  mediaRef: React.MutableRefObject<HTMLDivElement>;
};

type Props = MediaListing;

const MediaListing: React.FC<Props> = (props) => {
  const isMobile = useIsMobile();
  const { featuredItem, items, isMediaWall, mediaRef, isDark } = props;
  const { t } = useTranslations();

  const [videoUrl, setVideoUrl] = useState('');

  const hasItems = !!items.length;
  const hasFeaturedItem = featuredItem?.title && featuredItem?.description;
  const noItemsMediaWall = isMediaWall && !hasItems;
  const noItemsMediaList = !isMediaWall && !hasItems && !hasFeaturedItem;

  const closeVideoModal = () => {
    setVideoUrl('');
  };

  const renderListElement = (item) => {
    return (
      <ListElement key={item.id} isDark={isDark}>
        <MediaItem
          item={item}
          onVideoClick={setVideoUrl}
          displayLanguage={isMediaWall}
          isDark={isDark}
        />
      </ListElement>
    );
  };

  return (
    <>
      <Wrapper ref={mediaRef}>
        {noItemsMediaList && (
          <NoDataNotification
            title={t('media.filters.no_matches.title')}
            text={t('media.noMediaAvailable')}
            icon={<Icon icon='img_noResults' size='7.5rem' />}
          />
        )}
        {noItemsMediaWall && (
          <NoDataNotification
            title={t('media.filters.no_matches.title')}
            text={t('media.filters.no_matches.description')}
            icon={<Icon icon='img_noResults' size='7.5rem' />}
          />
        )}
        {!isMobile && featuredItem?.title && (
          <CardWrapper isDark={isDark}>
            <MediaItem
              item={featuredItem}
              onVideoClick={setVideoUrl}
              displayLanguage={isMediaWall}
              isFeatured
              isDark={isDark}
            />
          </CardWrapper>
        )}
        {hasItems && (
          <CardWrapper
            margin={!isMobile && featuredItem ? '2.4rem 0 0' : '0'}
            isDark={isDark}
          >
            <List isDark={isDark}>
              {isMobile &&
                featuredItem?.title &&
                renderListElement(featuredItem)}
              {items.map((item) => renderListElement(item))}
            </List>
          </CardWrapper>
        )}
      </Wrapper>
      {videoUrl && (
        <Overlay>
          <BackgroundLayer onClick={closeVideoModal}>
            <VideoModal>
              <VideoLink
                url={videoUrl}
                videoHeight='608px'
                backgroundColor='white'
              />
              <CloseWrapper onClick={closeVideoModal}>
                <Icon icon='icn_cross' size='20px' color={`${colors.White}`} />
              </CloseWrapper>
            </VideoModal>
          </BackgroundLayer>
        </Overlay>
      )}
    </>
  );
};

export default MediaListing;
